import React, { useState, useEffect } from 'react';
import { IconButton, Typography, Select, MenuItem, InputBase } from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight, FirstPage, LastPage } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import styles from './PaginationBarStyles';
import { isMobile } from 'react-device-detect';

const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing.unit * 3
    }
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    width: 'auto',
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      'Sura Sans',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
    }
  }
}))(InputBase);

const PaginationBar = ({
  classes,
  rows,
  selectedRows,
  withActions,
  totalSum,
  currentRecords,
  totalRecords,
  totalPagesPending,
  getDataTable,
  agentId,
  paymentToken,
  currentPage,
  type,
  selectedData,
  totalSummn,
  setOrderParams,
  orderParams,
  selectedReferences
}) => {
  const [page, setPage] = useState(() => {
    return JSON.parse(localStorage.getItem('currentPage'));
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    return JSON.parse(localStorage.getItem('rowsPerPage')) || 10;
  });
  const storedSearchValues = JSON.parse(localStorage.getItem('searchValues')) || {};

  useEffect(() => {
    localStorage.setItem('currentPage', JSON.stringify(page));
    localStorage.setItem('rowsPerPage', JSON.stringify(rowsPerPage));
    localStorage.setItem('selectedFilters', JSON.stringify([]));
    localStorage.setItem('searchValues', JSON.stringify({}));
  }, [page, rowsPerPage]);

  const applyOrderChange = selectedOrder => {
    let order_by = '';
    let order_dir = '';

    switch (selectedOrder) {
      case 'Inicio de Vigencia ASC':
        order_by = 'issue_date';
        order_dir = 'asc';
        break;
      case 'Inicio de Vigencia DESC':
        order_by = 'issue_date';
        order_dir = 'desc';
        break;
      case 'Fin de Vigencia ASC':
        order_by = 'due_date';
        order_dir = 'asc';
        break;
      case 'Fin de Vigencia DESC':
        order_by = 'due_date';
        order_dir = 'desc';
        break;
      case 'Fecha límite de pago ASC':
        order_by = 'extension_date';
        order_dir = 'asc';
        break;
      case 'Fecha límite de pago DESC':
        order_by = 'extension_date';
        order_dir = 'desc';
        break;
      case 'Importe ASC':
        order_by = 'total';
        order_dir = 'asc';
        break;
      case 'Importe DESC':
        order_by = 'total';
        order_dir = 'desc';
        break;
      case 'Subgrupo ASC':
        order_by = 'subgroup_id';
        order_dir = 'asc';
        break;
      case 'Subgrupo DESC':
        order_by = 'subgroup_id';
        order_dir = 'desc';
        break;
      case 'Grupo ASC':
        order_by = 'group_id';
        order_dir = 'asc';
        break;
      case 'Grupo DESC':
        order_by = 'group_id';
        order_dir = 'desc';
        break;
      default:
        order_by = '';
        order_dir = '';
        break;
    }

    localStorage.setItem('selectedOrderOption', selectedOrder);

    setOrderParams({ order_by, order_dir });
  };

  const handleChangePage = (event, newPage) => {
    const selectedOrder = localStorage.getItem('selectedOrderOption');
    applyOrderChange(selectedOrder);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    const newRowsPerPage = event.target.value;
    const selectedOrder = localStorage.getItem('selectedOrderOption');
    applyOrderChange(selectedOrder);

    setRowsPerPage(newRowsPerPage);
    setPage(1);
  };

  const renderPaginationCircles = () => {
    const totalPages = totalPagesPending;
    const paginationItems = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        paginationItems.push(
          <li
            key={i}
            className={`${classes.circle} ${i === page ? 'active' : ''}`}
            onClick={() => handleChangePage(null, i)}
          >
            {i}
          </li>
        );
      }
    } else {
      paginationItems.push(
        <li
          key={1}
          className={`${classes.circle} ${1 === page ? 'active' : ''}`}
          onClick={() => handleChangePage(null, 1)}
        >
          1
        </li>
      );

      if (page <= 3) {
        for (let i = 2; i < maxVisiblePages; i++) {
          paginationItems.push(
            <li
              key={i}
              className={`${classes.circle} ${i === page ? 'active' : ''}`}
              onClick={() => handleChangePage(null, i)}
            >
              {i}
            </li>
          );
        }
        paginationItems.push(
          <li key="end-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        paginationItems.push(
          <li
            key={totalPages}
            className={`${classes.circle} ${totalPages === page ? 'active' : ''}`}
            onClick={() => handleChangePage(null, totalPages)}
          >
            {totalPages}
          </li>
        );
      } else if (page >= totalPages - 2) {
        paginationItems.push(
          <li key="start-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        for (let i = totalPages - 3; i < totalPages; i++) {
          paginationItems.push(
            <li
              key={i}
              className={`${classes.circle} ${i === page ? 'active' : ''}`}
              onClick={() => handleChangePage(null, i)}
            >
              {i}
            </li>
          );
        }
        paginationItems.push(
          <li
            key={totalPages}
            className={`${classes.circle} ${totalPages === page ? 'active' : ''}`}
            onClick={() => handleChangePage(null, totalPages)}
          >
            {totalPages}
          </li>
        );
      } else {
        paginationItems.push(
          <li key="start-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        for (let i = page - 1; i <= page + 1; i++) {
          paginationItems.push(
            <li
              key={i}
              className={`${classes.circle} ${i === page ? 'active' : ''}`}
              onClick={() => handleChangePage(null, i)}
            >
              {i}
            </li>
          );
        }
        paginationItems.push(
          <li key="end-ellipsis" className={classes.circle} style={{ pointerEvents: 'none' }}>
            ...
          </li>
        );
        paginationItems.push(
          <li
            key={totalPages}
            className={`${classes.circle} ${totalPages === page ? 'active' : ''}`}
            onClick={() => handleChangePage(null, totalPages)}
          >
            {totalPages}
          </li>
        );
      }
    }

    return <ul className={classes.paginationCircles}>{paginationItems}</ul>;
  };

  const getReceiptText = () => {
    return selectedRows.length !== 1 ? 'RECIBOS SELECCIONADOS' : 'RECIBO SELECCIONADO';
  };
  const getReferencesText = () => {
    return selectedRows.length !== 1 ? 'REFERENCIAS SELECCIONADAS' : 'REFERENCIA SELECCIONADA';
  };

  const getCurrencyText = () => {
    if (selectedData.length > 0) {
      return selectedData.some(item => ['MXP', 'MXN'].includes(item.currency)) ? 'MXN' : 'USD';
    } else {
      return 'MXN';
    }
  };
  return (
    <React.Fragment>
      {!isMobile && (
        <div
          style={{
            width: 'calc(100vw-100px)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#EBEFF0',
            borderRadius: '0 0 5px 5px'
          }}
        >
          {type !== 'summary' ? (
            <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '1rem', height: '55px' }}>
              <div className={classes.pagination}>
                <IconButton className={classes.paginationArrow} onClick={event => handleChangePage(event, 1)} disabled={page === 1}>
                  <FirstPage />
                </IconButton>
                <IconButton className={classes.paginationArrow} onClick={event => handleChangePage(event, page - 1)} disabled={page === 1}>
                  <KeyboardArrowLeft />
                </IconButton>
                {renderPaginationCircles()}
                <IconButton className={classes.paginationArrow} onClick={event => handleChangePage(event, page + 1)} disabled={page >= totalPagesPending}>
                  <KeyboardArrowRight />
                </IconButton>
                <IconButton
                  className={classes.paginationArrow}
                  onClick={event => handleChangePage(event, totalPagesPending)}
                  disabled={page >= totalPagesPending}
                >
                  <LastPage />
                </IconButton>
              </div>
              <Typography className={classes.textCenter}>Mostrar</Typography>
              <Select
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                input={<BootstrapInput name="rowsPerPage" id="rowsPerPage-customized-select" />}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
                <MenuItem value={40}>40</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
              <Typography className={classes.textCenter}>Filas por página</Typography>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '1rem', height: '55px' }} />
          )}

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '1rem',
              alignItems: 'center',
              paddingRight: '10px'
            }}
          >
            {type !== 'paid_unapplied' && type !== 'paid_applied' && type !== 'referenced_payments' && (
              <React.Fragment>
                <Typography className={classes.textPolicy}>
                  {selectedData.filter(item => typeof item === 'object').length}{' '}
                </Typography>
                <Typography className={classes.textSelecteds}>{getReceiptText()} </Typography>
              </React.Fragment>
            )}
            {type === 'referenced_payments' && (
              <React.Fragment>
                <Typography className={classes.textPolicy}>{selectedReferences.length} </Typography>
                <Typography className={classes.textSelecteds}>{getReferencesText()} </Typography>
              </React.Fragment>
            )}
            {!withActions && type === 'pending' && (
              <Typography style={{ color: '#2D6DF6', fontFamily: 'Sura Sans' }} className={classes.textFooter}>
                {getCurrencyText()}
              </Typography>
            )}
            {!withActions && type === 'pending' && (
              <Typography style={{ color: '#2D6DF6', fontFamily: 'Sura Sans' }} className={classes.textFooters}>
                {getCurrencyText() === 'USD' ? totalSum : totalSummn}
              </Typography>
            )}
          </div>
        </div>
      )}
      {isMobile && (
        <div
          style={{
            width: 'calc(100vw-100px)',
            display: 'flex',
            justifyContent: 'space-between',
            background: '#EBEFF0',
            flexDirection: 'column',
            paddingBottom: '10px'
          }}
        >
          {type !== 'summary' ? (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', height: '55px' }}>
              <div className={classes.pagination}>
                <IconButton className={classes.paginationArrow} onClick={event => handleChangePage(event, 1)} disabled={page === 1}>
                  <FirstPage />
                </IconButton>
                <IconButton className={classes.paginationArrow} onClick={event => handleChangePage(event, page - 1)} disabled={page === 1}>
                  <KeyboardArrowLeft />
                </IconButton>
                {renderPaginationCircles()}
                <IconButton className={classes.paginationArrow} onClick={event => handleChangePage(event, page + 1)} disabled={page >= totalPagesPending}>
                  <KeyboardArrowRight />
                </IconButton>
                <IconButton
                  className={classes.paginationArrow}
                  onClick={event => handleChangePage(event, totalPagesPending)}
                  disabled={page >= totalPagesPending}
                >
                  <LastPage />
                </IconButton>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '1rem', height: '55px' }} />
          )}
          {type !== 'summary' && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <Typography className={classes.textCenter}>Mostrar</Typography>
              <Select
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                input={<BootstrapInput name="rowsPerPage" id="rowsPerPage-customized-select" />}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
                <MenuItem value={40}>40</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
              <Typography className={classes.textCenter}>Filas por página</Typography>
            </div>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '1rem',
              alignItems: 'center'
            }}
          >
            {type !== 'paid_unapplied' && type !== 'paid_applied' && type !== 'referenced_payments' && (
              <React.Fragment>
                <Typography className={classes.textPolicy}>{selectedRows.length} </Typography>
                <Typography className={classes.textSelecteds}>{getReceiptText()} </Typography>
              </React.Fragment>
            )}
            {type === 'referenced_payments' && (
              <React.Fragment>
                <Typography className={classes.textPolicy}>{selectedReferences.length} </Typography>
                <Typography className={classes.textSelecteds}>{getReferencesText()} </Typography>
              </React.Fragment>
            )}

            {!withActions && type === 'pending' && (
              <Typography style={{ color: '#2D6DF6' }} className={classes.textFooter}>
                {getCurrencyText()}
              </Typography>
            )}
            {!withActions && type === 'pending' && (
              <Typography style={{ color: '#2D6DF6' }} className={classes.textFooters}>
                {getCurrencyText() === 'USD' ? totalSum : totalSummn}
              </Typography>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default withStyles(styles)(PaginationBar);



// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/paginationBar/PaginationBar.js